import { render, staticRenderFns } from "./AssetScrapList.vue?vue&type=template&id=3f08fa49&scoped=true&"
import script from "./AssetScrapList.vue?vue&type=script&lang=js&"
export * from "./AssetScrapList.vue?vue&type=script&lang=js&"
import style0 from "./AssetScrapList.vue?vue&type=style&index=0&id=3f08fa49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f08fa49",
  null
  
)

export default component.exports